module.exports = __webpack_public_path__ + "img/open_in_browser.3b186ef0.png";